// Comprehensive Exercise Database with detailed information
export const defaultExercises = [
  // CHEST
  {
    id: 1,
    name: 'Push-up',
    bodyPart: 'chest',
    target: 'pectorals',
    category: 'chest',
    equipment: 'body weight',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Push-up',
    description: 'Classic bodyweight chest exercise',
    sets: '3',
    reps: '8-12',
    rest: '60-90 sec',
    notes: 'Control the descent. Explosive up, controlled down.'
  },
  {
    id: 2,
    name: 'Bench Press',
    bodyPart: 'chest',
    target: 'pectorals',
    category: 'chest',
    equipment: 'barbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Bench+Press',
    description: 'Primary compound chest movement',
    sets: '4',
    reps: '6-12',
    rest: '2-3 min',
    notes: 'Keep feet flat. Lower to chest level.'
  },
  {
    id: 3,
    name: 'Dumbbell Press',
    bodyPart: 'chest',
    target: 'pectorals',
    category: 'chest',
    equipment: 'dumbbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=DB+Press',
    description: 'Unilateral chest pressing movement',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Greater range of motion than barbell.'
  },
  {
    id: 4,
    name: 'Machine Chest Press',
    bodyPart: 'chest',
    target: 'pectorals',
    category: 'chest',
    equipment: 'machine',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Machine+Press',
    description: 'Guided chest pressing on machine',
    sets: '3',
    reps: '8-12',
    rest: '60-90 sec',
    notes: 'Good for learning proper form.'
  },

  // BACK
  {
    id: 5,
    name: 'Pull-up',
    bodyPart: 'back',
    target: 'lats',
    category: 'back',
    equipment: 'body weight',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Pull-up',
    description: 'Bodyweight back pulling exercise',
    sets: '3',
    reps: '5-12',
    rest: '2-3 min',
    notes: 'Full range of motion. Assisted if needed.'
  },
  {
    id: 6,
    name: 'Barbell Row',
    bodyPart: 'back',
    target: 'lats',
    category: 'back',
    equipment: 'barbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Barbell+Row',
    description: 'Primary compound back movement',
    sets: '4',
    reps: '6-12',
    rest: '2-3 min',
    notes: 'Keep chest up. Drive through heels.'
  },
  {
    id: 7,
    name: 'Dumbbell Row',
    bodyPart: 'back',
    target: 'lats',
    category: 'back',
    equipment: 'dumbbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=DB+Row',
    description: 'Unilateral back rowing movement',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Squeeze at the top. Feel the muscle working.'
  },
  {
    id: 8,
    name: 'Lat Pulldown',
    bodyPart: 'back',
    target: 'lats',
    category: 'back',
    equipment: 'machine',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Lat+Pulldown',
    description: 'Machine-based lat pulling exercise',
    sets: '3',
    reps: '8-12',
    rest: '60-90 sec',
    notes: 'Pull elbows down and back. Full range of motion.'
  },

  // SHOULDERS
  {
    id: 9,
    name: 'Shoulder Press',
    bodyPart: 'shoulders',
    target: 'deltoids',
    category: 'shoulders',
    equipment: 'barbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Shoulder+Press',
    description: 'Primary compound shoulder movement',
    sets: '4',
    reps: '6-12',
    rest: '2-3 min',
    notes: 'Control the descent. Explosive up, controlled down.'
  },
  {
    id: 10,
    name: 'Lateral Raise',
    bodyPart: 'shoulders',
    target: 'deltoids',
    category: 'shoulders',
    equipment: 'dumbbell',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Lateral+Raise',
    description: 'Isolation shoulder exercise',
    sets: '3',
    reps: '10-15',
    rest: '60-90 sec',
    notes: 'Controlled movement. Avoid momentum.'
  },
  {
    id: 11,
    name: 'Pike Push-up',
    bodyPart: 'shoulders',
    target: 'deltoids',
    category: 'shoulders',
    equipment: 'body weight',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Pike+Push-up',
    description: 'Bodyweight shoulder pressing variation',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Form pike position. Lower head toward ground.'
  },
  {
    id: 12,
    name: 'Machine Shoulder Press',
    bodyPart: 'shoulders',
    target: 'deltoids',
    category: 'shoulders',
    equipment: 'machine',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Machine+Press',
    description: 'Guided shoulder pressing on machine',
    sets: '3',
    reps: '8-12',
    rest: '60-90 sec',
    notes: 'Good for learning proper form.'
  },

  // UPPER ARMS
  {
    id: 13,
    name: 'Bicep Curl',
    bodyPart: 'upper arms',
    target: 'biceps',
    category: 'arms',
    equipment: 'dumbbell',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Bicep+Curl',
    description: 'Primary bicep isolation exercise',
    sets: '3',
    reps: '8-12',
    rest: '60-90 sec',
    notes: 'Squeeze at the top. Feel the muscle working.'
  },
  {
    id: 14,
    name: 'Tricep Dip',
    bodyPart: 'upper arms',
    target: 'triceps',
    category: 'arms',
    equipment: 'body weight',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Tricep+Dip',
    description: 'Bodyweight tricep exercise',
    sets: '3',
    reps: '6-12',
    rest: '90-120 sec',
    notes: 'Lower until elbows are 90°. Full range.'
  },
  {
    id: 15,
    name: 'Barbell Curl',
    bodyPart: 'upper arms',
    target: 'biceps',
    category: 'arms',
    equipment: 'barbell',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Barbell+Curl',
    description: 'Barbell bicep curling movement',
    sets: '3',
    reps: '6-12',
    rest: '90-120 sec',
    notes: 'Keep elbows stationary. Strict form.'
  },
  {
    id: 16,
    name: 'Cable Curl',
    bodyPart: 'upper arms',
    target: 'biceps',
    category: 'arms',
    equipment: 'cable',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Cable+Curl',
    description: 'Cable machine bicep exercise',
    sets: '3',
    reps: '8-12',
    rest: '60-90 sec',
    notes: 'Constant tension throughout movement.'
  },

  // UPPER LEGS
  {
    id: 17,
    name: 'Bodyweight Squat',
    bodyPart: 'upper legs',
    target: 'quads',
    category: 'legs',
    equipment: 'body weight',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Squat',
    description: 'Bodyweight leg exercise',
    sets: '3',
    reps: '12-15',
    rest: '90-120 sec',
    notes: 'Keep chest up. Drive through heels.'
  },
  {
    id: 18,
    name: 'Barbell Squat',
    bodyPart: 'upper legs',
    target: 'quads',
    category: 'legs',
    equipment: 'barbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Barbell+Squat',
    description: 'Primary compound leg movement',
    sets: '4',
    reps: '6-12',
    rest: '2-3 min',
    notes: 'Depth to parallel or below. Full range.'
  },
  {
    id: 19,
    name: 'Leg Press',
    bodyPart: 'upper legs',
    target: 'quads',
    category: 'legs',
    equipment: 'machine',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Leg+Press',
    description: 'Machine-based leg pressing exercise',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Full range of motion. Controlled descent.'
  },
  {
    id: 20,
    name: 'Leg Curl',
    bodyPart: 'upper legs',
    target: 'hamstrings',
    category: 'legs',
    equipment: 'machine',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Leg+Curl',
    description: 'Hamstring isolation exercise',
    sets: '3',
    reps: '8-12',
    rest: '60-90 sec',
    notes: 'Squeeze at the top. Controlled movement.'
  },

  // LOWER LEGS
  {
    id: 21,
    name: 'Calf Raise',
    bodyPart: 'lower legs',
    target: 'calves',
    category: 'legs',
    equipment: 'barbell',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Calf+Raise',
    description: 'Barbell calf raising exercise',
    sets: '3',
    reps: '12-15',
    rest: '60-90 sec',
    notes: 'Full range of motion. Pause at top.'
  },
  {
    id: 22,
    name: 'Seated Calf Raise',
    bodyPart: 'lower legs',
    target: 'calves',
    category: 'legs',
    equipment: 'machine',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Seated+Calf+Raise',
    description: 'Machine-based calf exercise',
    sets: '3',
    reps: '12-15',
    rest: '60-90 sec',
    notes: 'Targets soleus muscle. Full range.'
  },

  // CORE
  {
    id: 23,
    name: 'Plank',
    bodyPart: 'waist',
    target: 'abs',
    category: 'core',
    equipment: 'body weight',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Plank',
    description: 'Isometric core exercise',
    sets: '3',
    reps: '30-60 sec',
    rest: '60-90 sec',
    notes: 'Keep body straight. Engage core throughout.'
  },
  {
    id: 24,
    name: 'Crunch',
    bodyPart: 'waist',
    target: 'abs',
    category: 'core',
    equipment: 'body weight',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Crunch',
    description: 'Abdominal flexion exercise',
    sets: '3',
    reps: '12-15',
    rest: '60-90 sec',
    notes: 'Crunch up, not pull. Feel the abs contract.'
  },
  {
    id: 25,
    name: 'Cable Crunch',
    bodyPart: 'waist',
    target: 'abs',
    category: 'core',
    equipment: 'cable',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Cable+Crunch',
    description: 'Cable machine ab exercise',
    sets: '3',
    reps: '12-15',
    rest: '60-90 sec',
    notes: 'Constant tension. Full range of motion.'
  },

  // ADDITIONAL CHEST EXERCISES
  {
    id: 26,
    name: 'Incline Dumbbell Press',
    bodyPart: 'chest',
    target: 'upper pectorals',
    category: 'chest',
    equipment: 'dumbbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Incline+DB+Press',
    description: 'Targets upper chest with incline angle',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Set bench to 30-45 degrees. Greater range of motion.'
  },
  {
    id: 27,
    name: 'Decline Bench Press',
    bodyPart: 'chest',
    target: 'lower pectorals',
    category: 'chest',
    equipment: 'barbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Decline+Press',
    description: 'Emphasizes lower chest development',
    sets: '3',
    reps: '6-12',
    rest: '2-3 min',
    notes: 'Lower to chest level. Explosive up.'
  },
  {
    id: 28,
    name: 'Cable Fly',
    bodyPart: 'chest',
    target: 'pectorals',
    category: 'chest',
    equipment: 'cable',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Cable+Fly',
    description: 'Isolation chest exercise with constant tension',
    sets: '3',
    reps: '10-15',
    rest: '60-90 sec',
    notes: 'Squeeze at the center. Controlled movement.'
  },

  // ADDITIONAL BACK EXERCISES
  {
    id: 29,
    name: 'Seal Row',
    bodyPart: 'back',
    target: 'lats',
    category: 'back',
    equipment: 'barbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Seal+Row',
    description: 'Chest-supported rowing variation',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Reduces lower back strain. Full range of motion.'
  },
  {
    id: 30,
    name: 'T-Bar Row',
    bodyPart: 'back',
    target: 'lats',
    category: 'back',
    equipment: 'barbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=T-Bar+Row',
    description: 'Compound back movement with neutral grip',
    sets: '4',
    reps: '6-12',
    rest: '2-3 min',
    notes: 'Drive through heels. Explosive up.'
  },
  {
    id: 31,
    name: 'Face Pull',
    bodyPart: 'back',
    target: 'rear deltoids',
    category: 'back',
    equipment: 'cable',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Face+Pull',
    description: 'Rear delt and upper back exercise',
    sets: '3',
    reps: '12-15',
    rest: '60-90 sec',
    notes: 'Pull rope to face. Squeeze shoulder blades.'
  },

  // ADDITIONAL SHOULDER EXERCISES
  {
    id: 32,
    name: 'Reverse Pec Deck',
    bodyPart: 'shoulders',
    target: 'rear deltoids',
    category: 'shoulders',
    equipment: 'machine',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Reverse+Pec+Deck',
    description: 'Machine-based rear delt isolation',
    sets: '3',
    reps: '10-15',
    rest: '60-90 sec',
    notes: 'Controlled movement. Feel the rear delts.'
  },
  {
    id: 33,
    name: 'Dumbbell Shoulder Press',
    bodyPart: 'shoulders',
    target: 'deltoids',
    category: 'shoulders',
    equipment: 'dumbbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=DB+Shoulder+Press',
    description: 'Unilateral shoulder pressing movement',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Greater range of motion. Stabilizer muscles engaged.'
  },
  {
    id: 34,
    name: 'Upright Row',
    bodyPart: 'shoulders',
    target: 'deltoids',
    category: 'shoulders',
    equipment: 'barbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Upright+Row',
    description: 'Compound shoulder and trap movement',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Keep elbows high. Controlled descent.'
  },

  // ADDITIONAL ARM EXERCISES
  {
    id: 35,
    name: 'Overhead Tricep Extension',
    bodyPart: 'upper arms',
    target: 'triceps',
    category: 'arms',
    equipment: 'dumbbell',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Overhead+Tricep',
    description: 'Isolation tricep exercise',
    sets: '3',
    reps: '10-12',
    rest: '60-90 sec',
    notes: 'Full range of motion. Squeeze at top.'
  },
  {
    id: 36,
    name: 'Preacher Curl',
    bodyPart: 'upper arms',
    target: 'biceps',
    category: 'arms',
    equipment: 'barbell',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Preacher+Curl',
    description: 'Isolation bicep exercise with support',
    sets: '3',
    reps: '8-12',
    rest: '60-90 sec',
    notes: 'Eliminates momentum. Strict form.'
  },
  {
    id: 37,
    name: 'Rope Tricep Pushdown',
    bodyPart: 'upper arms',
    target: 'triceps',
    category: 'arms',
    equipment: 'cable',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Rope+Pushdown',
    description: 'Cable tricep isolation exercise',
    sets: '3',
    reps: '10-15',
    rest: '60-90 sec',
    notes: 'Constant tension. Full range of motion.'
  },

  // ADDITIONAL LEG EXERCISES
  {
    id: 38,
    name: 'Romanian Deadlift',
    bodyPart: 'upper legs',
    target: 'hamstrings',
    category: 'legs',
    equipment: 'barbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=RDL',
    description: 'Hamstring and lower back compound movement',
    sets: '4',
    reps: '6-12',
    rest: '2-3 min',
    notes: 'Keep chest up. Feel hamstring stretch.'
  },
  {
    id: 39,
    name: 'Leg Extension',
    bodyPart: 'upper legs',
    target: 'quads',
    category: 'legs',
    equipment: 'machine',
    difficulty: 'beginner',
    gifUrl: 'https://via.placeholder.com/300x300?text=Leg+Extension',
    description: 'Quad isolation machine exercise',
    sets: '3',
    reps: '10-15',
    rest: '60-90 sec',
    notes: 'Full range of motion. Squeeze at top.'
  },
  {
    id: 40,
    name: 'Hack Squat',
    bodyPart: 'upper legs',
    target: 'quads',
    category: 'legs',
    equipment: 'machine',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Hack+Squat',
    description: 'Machine-based squat variation',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Depth to parallel. Controlled descent.'
  },
  {
    id: 41,
    name: 'Bulgarian Split Squat',
    bodyPart: 'upper legs',
    target: 'quads',
    category: 'legs',
    equipment: 'dumbbell',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Bulgarian+Split+Squat',
    description: 'Unilateral leg exercise with rear foot elevated',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Front knee over ankle. Full range of motion.'
  },

  // ADDITIONAL CORE EXERCISES
  {
    id: 42,
    name: 'Ab Wheel Rollout',
    bodyPart: 'waist',
    target: 'abs',
    category: 'core',
    equipment: 'body weight',
    difficulty: 'advanced',
    gifUrl: 'https://via.placeholder.com/300x300?text=Ab+Wheel',
    description: 'Advanced core stability exercise',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Full range of motion. Engage core throughout.'
  },
  {
    id: 43,
    name: 'Hanging Leg Raise',
    bodyPart: 'waist',
    target: 'abs',
    category: 'core',
    equipment: 'body weight',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Hanging+Leg+Raise',
    description: 'Bodyweight ab exercise on pull-up bar',
    sets: '3',
    reps: '8-12',
    rest: '90-120 sec',
    notes: 'Control the swing. Full range of motion.'
  },
  {
    id: 44,
    name: 'Pallof Press',
    bodyPart: 'waist',
    target: 'obliques',
    category: 'core',
    equipment: 'cable',
    difficulty: 'intermediate',
    gifUrl: 'https://via.placeholder.com/300x300?text=Pallof+Press',
    description: 'Anti-rotation core exercise',
    sets: '3',
    reps: '10-12',
    rest: '60-90 sec',
    notes: 'Resist rotation. Controlled movement.'
  }
];

export const exerciseCategories = [
  { value: 'chest', label: 'Chest' },
  { value: 'back', label: 'Back' },
  { value: 'shoulders', label: 'Shoulders' },
  { value: 'arms', label: 'Arms' },
  { value: 'legs', label: 'Legs' },
  { value: 'core', label: 'Core' },
];

export const equipmentOptions = [
  { value: 'body weight', label: 'Body Weight' },
  { value: 'barbell', label: 'Barbell' },
  { value: 'dumbbell', label: 'Dumbbell' },
  { value: 'machine', label: 'Machine' },
  { value: 'cable', label: 'Cable' },
  { value: 'kettlebell', label: 'Kettlebell' },
  { value: 'band', label: 'Resistance Band' },
];

export const difficultyLevels = [
  { value: 'beginner', label: 'Beginner' },
  { value: 'intermediate', label: 'Intermediate' },
  { value: 'advanced', label: 'Advanced' },
];
